import { render, staticRenderFns } from "./PurchaseAgingDetail.vue?vue&type=template&id=b612c134"
import script from "./PurchaseAgingDetail.vue?vue&type=script&lang=js"
export * from "./PurchaseAgingDetail.vue?vue&type=script&lang=js"
import style0 from "./PurchaseAgingDetail.vue?vue&type=style&index=0&id=b612c134&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports